import {
  DropdownDivider,
  DropdownItem,
  DropdownItemDescription,
  DropdownItemTitle,
  DropdownTitle,
} from '@/components/Dropdown'
import { type JobMenuSection } from '@/features/jobs/details/JobActionsViewModel'

export interface JobActionsMenuItemsProps {
  sections: JobMenuSection[]
}

/**
 * The items of a job's actions dropdown.
 */
export function JobActionsMenuItems({ sections }: JobActionsMenuItemsProps) {
  return sections.map((section, index) => (
    <JobActionsMenuSection key={section.title ?? index} section={section} />
  ))
}

interface JobActionsMenuSectionProps {
  section: JobMenuSection
}

function JobActionsMenuSection({ section }: JobActionsMenuSectionProps) {
  return (
    <>
      {section.title && (
        <>
          <DropdownDivider />
          <DropdownTitle>{section.title}</DropdownTitle>
        </>
      )}
      {section.actions.map((action) => (
        <DropdownItem
          key={action.title}
          isDisabled={action.isDisabled}
          onPress={action.onSelect}
          testId={action.testId}
        >
          <DropdownItemTitle>{action.title}</DropdownItemTitle>
          {action.description && (
            <DropdownItemDescription>
              {action.description}
            </DropdownItemDescription>
          )}
        </DropdownItem>
      ))}
    </>
  )
}
